import FilterableList from './FilterableList'
import LoadMore from './LoadMore'
import VideosPage from './VideosPage'

export default function Videos(Vue) {
  Vue.component('FilterableList', FilterableList)
  Vue.component('LoadMore', LoadMore)
  Vue.component('VideosPage', VideosPage)



  function RenderComponent(template) {
    const _renderer = Vue.compile(template)
    return {
      render: _renderer.render,
      staticRenderFns: _renderer.staticRenderFns
    }
  }
  
  Vue.component('renderer', {
    // functional: true,
    render(h) {
      if ('object' == typeof this.result) {
        if (this.dataRes) {
          return h(
            'Videos', {
              is: this.component,
              props: {
                dataResult: this.dataRes
              }
            }
          )
        } 
        return h('div', this.$slots.default)
        
      } 
      if (this.result) {
        return h(
          'Videos', {
            is: this.component,
          }
        )
      } 
      return h('div', this.$slots.default)
    },
    props: ['result', 'dataRes'],
    data() {
      return {
        component: '',
        False: false,
        True: true, 
        None: undefined
      }
    },
    mounted() {

    },
    watch: {

      result: {
        handler(nval) {
          if (nval) {
            if ('object' == typeof nval) {
              this.component = nval.val
            } else {
              this.component = RenderComponent(nval)
            }
          }
        },
        immediate: true
      }
      // result(nval) {
      //   console.log(nval, typeof nval)
      //   if (typeof nval == Object) {
      //     this.component = nval.val
      //   } else {
      //     console.log(nval)
      //     this.component = RenderComponent(nval)
      //   }
      //   // this.component = RenderComponent(nval)
      // }

    }
  })

} 



// WEBPACK FOOTER //
// ./src/js/shared/components/videos/index.js